export function FacebookProductBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    isElementEditable: true,
    editElementModalController: 'editFacebookProductBoxController',
    editElementModalTemplate: require('./editFacebookProductBox.modal.html'),

    angularTemplate: `
<div layout="column">
  <span class="alc-label-text" translate-once="parameters/quick_replies/details/graph/edit_facebook_product_box_product_id_label"></span>
  <span>{{ elementData.productId }}</span>
  <span class="alc-label-text alc-padding-top-10" translate-once="parameters/quick_replies/details/graph/edit_facebook_product_box_variable_name_label"></span>
  <span>{{ elementData.variableName }}</span>
</div>
`,

  });
}
